
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorDeCurso } from '../../controlador-detalles';
    import { Curso } from '@/__env/lib/Cursos';
    import preguntas  from './cursos-detalles-resumen-preguntas.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            preguntas ,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador(): ControladorDeCurso { return Model; }
        public get Curso(): Curso { return this.Controlador.Curso; }
        public get Participante() { return this.Controlador.Seleccionado; }
        public get Resultado() { return this.Controlador.Seleccionado.Resultado; }

        public Estado: string = 'cargando';
        public SubModo: string = '';


        protected Eventos: Function[] = [];
        beforeDestroy() { this.Eventos.forEach( x => x() ); }
        async mounted()
        {
            this.SubModo = this.Controlador.Vista.SubModo;
            this.Eventos.push( this.Controlador.Vista.onSubModo.subscribe( () => this.SubModo = this.Controlador.Vista.SubModo ) );

            await this.Participante.cargarResultado();
            await this.Participante.Resultado.CargarRespuestas();
            this.Estado = 'ok';
        }


    }
